export function printReport(id: string, title: string, orientation: 'portrait' | 'landscape' = 'landscape') {
    const element = document.getElementById(id);
    if (!element) return;
    const popup = window.open('', '_blank');
    if (!popup) return;
    popup.document.write('<!doctype html><html lang="fa" dir="rtl"><head><meta charset="utf-8"><title></title></head><body></body></html>');
    popup.document.title = title;
    document.querySelectorAll('style, link[rel="stylesheet"]').forEach(node => popup.document.head.appendChild(node.cloneNode(true)));
    const style = popup.document.createElement('style');
    style.textContent = `@page{size:A4 ${orientation};margin:12mm}body{background:white!important;color:#111!important;padding:12px}button,.rmdp-container,.ant-collapse-expand-icon{display:none!important}.ant-card,.ant-table,.ant-table-cell{background:white!important;color:#111!important}.ant-table-content{overflow:visible!important}tr{break-inside:avoid}.ant-collapse-content{display:block!important}`;
    popup.document.head.appendChild(style);
    popup.document.body.appendChild(element.cloneNode(true));
    popup.onload = () => { void popup.document.fonts.ready.then(() => { popup.focus(); popup.print(); }); };
    popup.document.close();
}
